import { featureDisabledActionTypes } from '../constants/features';
export const getFeatureDisabledReason = ({
  hasScopes,
  hasScopeGroups
}) => {
  if (hasScopes && !hasScopeGroups) return featureDisabledActionTypes.reconnect;
  if (!hasScopes) return featureDisabledActionTypes.redirect;
  return undefined;
};